import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';

export default function Confidentialite() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0a0a0f] text-white min-h-screen">
      <Navbar scrolled={true} />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
            Politique de confidentialité
          </h1>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Introduction</h2>
              <p>La protection de vos données personnelles est une priorité pour <strong className="text-white">AI Exécutif Assistant</strong>. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos données.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Responsable du traitement</h2>
              <div className="bg-white/5 border border-white/10 rounded-lg p-6 space-y-2">
                <p><strong className="text-white">AI Exécutif Assistant</strong></p>
                <p>Heuby Jennifer</p>
                <p>50 avenue des Champs-Élysées, 75018 Paris, France</p>
                <p>Email : <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
                <p>Téléphone : <a href="tel:+33970703990" className="text-violet-400 hover:text-violet-300 transition-colors">+33 9 70 70 39 90</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Données collectées</h2>
              <p className="mb-3">Nous collectons les données suivantes :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Nom et prénom</li>
                <li>Adresse email professionnelle</li>
                <li>Numéro de téléphone</li>
                <li>Nom de l'entreprise</li>
                <li>Fonction / poste</li>
                <li>Informations relatives à votre demande ou projet</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Finalités du traitement</h2>
              <p className="mb-3">Vos données sont utilisées pour :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Répondre à vos demandes de contact</li>
                <li>Gérer les prises de rendez-vous</li>
                <li>Fournir nos services d'assistance exécutive IA</li>
                <li>Améliorer nos services</li>
                <li>Vous envoyer des informations commerciales (avec votre consentement)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Base légale</h2>
              <p>Le traitement de vos données repose sur :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-3">
                <li>L'exécution d'un contrat ou de mesures précontractuelles</li>
                <li>Votre consentement explicite</li>
                <li>Notre intérêt légitime à développer notre activité</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Durée de conservation</h2>
              <p>Vos données sont conservées :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-3">
                <li>Pendant la durée de la relation commerciale</li>
                <li>3 ans après le dernier contact pour les prospects</li>
                <li>Conformément aux obligations légales en vigueur</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Vos droits</h2>
              <p className="mb-3">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-white">Droit d'accès</strong> : obtenir une copie de vos données</li>
                <li><strong className="text-white">Droit de rectification</strong> : corriger vos données inexactes</li>
                <li><strong className="text-white">Droit à l'effacement</strong> : supprimer vos données</li>
                <li><strong className="text-white">Droit à la limitation</strong> : limiter le traitement</li>
                <li><strong className="text-white">Droit d'opposition</strong> : vous opposer au traitement</li>
                <li><strong className="text-white">Droit à la portabilité</strong> : récupérer vos données</li>
              </ul>
              <p className="mt-4">Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Sécurité des données</h2>
              <p>Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou destruction.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
              <p>Notre site utilise des cookies pour améliorer votre expérience. Vous pouvez gérer vos préférences via les paramètres de votre navigateur.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Modifications</h2>
              <p>Cette politique peut être mise à jour. La version en vigueur est toujours disponible sur cette page.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
              <p>Pour toute question concernant cette politique :</p>
              <p className="mt-2">📧 <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
              <p>📞 <a href="tel:+33970703990" className="text-violet-400 hover:text-violet-300 transition-colors">+33 9 70 70 39 90</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}